module.exports = " <div class=sprite _v-59614f3e=\"\"> <canvas v-el:canvas=\"\" _v-59614f3e=\"\"></canvas> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-59614f3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sprite.vue
// module id = 761
// module chunks = 2